import { api } from './api';
import type { ApiResponse } from '@/types/api';

export interface Notification {
  id: string;
  recipient_id: string;
  notification_type: string;
  title: string;
  content: string;
  related_id?: string;
  related_type?: string;
  link_url?: string;
  is_read: number;
  read_at?: number;
  created_at: number;
}

export interface NotificationListResponse {
  list: Notification[];
  total: number;
  page: number;
  page_size: number;
  total_page: number;
}

export interface UnreadCountResponse {
  count: number;
}

class NotificationService {
  /**
   * 获取通知列表
   */
  async getNotifications(params?: {
    page?: number;
    page_size?: number;
    is_read?: number;
  }): Promise<NotificationListResponse> {
    return api.get<NotificationListResponse>('/notifications', { params });
  }

  async getUnreadCount(): Promise<UnreadCountResponse> {
    return api.get<UnreadCountResponse>('/notifications/unread-count');
  }

  /**
   * 标记单个通知为已读
   */
  async markAsRead(id: string): Promise<ApiResponse<any>> {
    return api.put(`/notifications/${id}/read`);
  }

  /**
   * 批量标记通知为已读
   */
  async batchMarkAsRead(ids: string[]): Promise<ApiResponse<any>> {
    return api.post('/notifications/batch-read', { ids });
  }

  /**
   * 标记所有通知为已读
   */
  async markAllAsRead(): Promise<ApiResponse<any>> {
    return api.post('/notifications/read-all');
  }

  /**
   * 删除通知
   */
  async deleteNotification(id: string): Promise<ApiResponse<any>> {
    return api.delete(`/notifications/${id}`);
  }
}

export const notificationService = new NotificationService();
